// extracted by mini-css-extract-plugin
module.exports = {"printFooter":"PrintFooter_printFooter__QqtlJ"};